export const emailRegex =
  /^([\w\d!#$%&'*+/=?^_`{|}~-]+(?:\.[\w\d!#$%&'*+/=?^_`{|}~-]+)*)@((?:[\w\d-]+\.)*\w[\w\d-]{0,66})\.([\w\d]{2,63}(?:\.[\w\d]{2})?)$/i
export const emailListRegex =
  /^([\w\d!#$%&'*+/=?^_`{|}~-]+(?:\.[\w\d!#$%&'*+/=?^_`{|}~-]+)*)@((?:[\w\d-]+\.)*\w[\w\d-]{0,66})\.([\w\d]{2,63}(?:\.[\w\d]{2})?)((,\s[\w\d!#$%&'*+/=?^_`{|}~-]+(?:\.[\w\d!#$%&'*+/=?^_`{|}~-]+)*)@((?:[\w\d-]+\.)*\w[\w\d-]{0,66})\.([\w\d]{2,63}(?:\.[\w\d]{2})?)+)*$/i

const emailRegexp = new RegExp(emailRegex)

const isValidEmail = (val: string): boolean => emailRegexp.test(val) && val.length <= 255

export default isValidEmail
